import React from 'react';
import Modal from '@mui/material/Modal';
import { Backdrop } from '@mui/material';
import { AddButton } from '../buttons';
import { CloseButton } from 'components';
import { Backgrounds, Colors } from 'utils';

export const SimpleModal = ({ openDefault, handleOpenClose, content, backdropCustom, addButton, bigSize, flexEnd }) => {
    const [open, setOpen] = React.useState(false);

    const handleOpenOrClose = () => {
        if (handleOpenClose) {
            handleOpenClose();
        } else {
            setOpen((prevState) => !prevState);
        }
    };

    const body = (
        <div
            className={bigSize ? 'open-sans' : 'open-sans modal-viewport-cap'}
            style={{ position: 'relative', width: bigSize ? '100%' : 'auto' }}
        >
            <div className="modal-header-style">
                <CloseButton handleCLic={handleOpenClose} />
            </div>
            <div className={bigSize ? 'modal-body-full' : 'modal-body-small'}>{content}</div>
        </div>
    );

    return (
        <>
            {addButton && <AddButton text={addButton} handleClick={handleOpenOrClose} />}
            <Modal
                open={openDefault ? openDefault : open}
                // onClose={handleOpenOrClose}
                aria-labelledby="spring-modal-title"
                aria-describedby="spring-modal-description"
                className={backdropCustom === true ? 'my-profile' : ''}
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: flexEnd ? 'flex-end' : 'center',
                }}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                {body}
            </Modal>
        </>
    );
};

export const CustomModal = ({ openDefault, handleOpenClose, content, backdropCustom }) => {
    const [open, setOpen] = React.useState(false);

    const handleClose = () => {
        if (handleOpenClose) {
            handleOpenClose();
        } else {
            setOpen(false);
        }
    };

    // The cap keeps fixed-width modal content (e.g. `width: 1280`) inside the viewport on small
    // laptops; see `.modal-viewport-cap` in globalStyles.scss.
    const body = <div className="modal-viewport-cap">{content}</div>;

    return (
        <div className={'open-sans'}>
            <Modal
                disableScrollLock={true}
                open={openDefault ? openDefault : open}
                // onClose={handleClose}
                aria-labelledby="spring-modal-title"
                aria-describedby="spring-modal-description"
                className={backdropCustom === true ? 'my-profile' : ''}
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    // zIndex: 2500,
                }}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                {body}
            </Modal>
        </div>
    );
};
